import {
    CollectionApi,
    CoreFetch, ListProviderRefundRequestsRequest,

    ProviderCollectionPayment, ProviderCollectionRefundRequest
} from '@enter/core';
import {IItemListing} from "./root.store";
import { fetch, parseResponse } from './util';

export class OverpaymentService {

    public async fetchOverpaymentRefundRequests(
        lprrr: ListProviderRefundRequestsRequest
    ): Promise<IItemListing<ProviderCollectionRefundRequest> | undefined> {
        const res = await fetch(lprrr, req => {
                console.log("req", req);
                return CoreFetch<CollectionApi>(CollectionApi).listProviderRefundRequestsRaw(req)
            }
        );
        if (res) {
            return {
                items: await parseResponse(res),
                limit: Number(await res.raw.headers.get('pagination-limit')),
                offset: Number(await res.raw.headers.get('pagination-offset')),
                total: Number(await res.raw.headers.get('pagination-total')),
            };
        }
    }

    public async unapproveRefundRequest(
        refundRequestId: string
    ): Promise<ProviderCollectionRefundRequest> {
        const res = await CoreFetch<CollectionApi>(CollectionApi).unapproveProviderRefundRequestRaw({id: refundRequestId});
        return await parseResponse(res);
    }

    public async approveRefundRequest(
        refundRequestId: string,
        notes: string|undefined
    ): Promise<ProviderCollectionRefundRequest> {
        const res = await CoreFetch<CollectionApi>(CollectionApi).approveProviderRefundRequestRaw({id: refundRequestId, providerRefundRequestNotesPayload: {notes}});
        return await parseResponse(res);
    }


}